<template>
  <div id="app">
    <sui-container>
      <div id="logo" @click="goHome" />
      <div id="banner" />

      <router-view />

      <Footer />
    </sui-container>

    <CookieLaw />
  </div>
</template>
<script>
  import Footer from '@/views/components/Footer.vue'
  import CookieLaw from '@/views/components/CookieLaw.vue'
  export default {
    name: 'app',
    components: {
      Footer,
      CookieLaw
    },
    methods: {
      goHome() {
        this.$router.push('/')
      },
    }
  }
</script>
<style lang="scss">
  @import '@/assets/scss/global.scss';
</style>
